import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import classes from "./Settings.module.css";
import Spinner from "react-bootstrap/Spinner";
import Button from "react-bootstrap/Button";
import Card from "react-bootstrap/Card";

import {envAwarePost} from '../../util/util'

import {
    updateDataPermissions,
    getDataPermissions
} from "./settingsSlice";

const ConnectFitbitButton = ()=>{
    const [isConnecting,setSsConnecting] = useState(false)
    const handleConnect = ()=>{
        setSsConnecting(true)
        envAwarePost(
            'api/third-party/',
            {action:'getFitbitAuthorizationLink'}
        ).then(res=>{
            window.location = res.data.link
        })
    }

    const [isConnected,setIsConnected] = useState(false)
    const [isCheckingConnection,setIsCheckingConnection] = useState(false)
    useEffect(()=>{
        setIsCheckingConnection(true)
        envAwarePost(
            'api/third-party/',
            {action:'checkFitbitConnection'}
        ).then(res=>{
            setIsCheckingConnection(false)
            setIsConnected(res.data.is_connected)
        })
    },[])

    return (
        <div>
            <Button 
                onClick={handleConnect} 
                disabled={isConnecting||isCheckingConnection} 
                variant="outline-info" 
                block
            >
                Connect Fitbit {isConnecting&&<Spinner animation='border' size="sm"/>}
            </Button>
            {isCheckingConnection?
                <small className="text-info">Checking Connection</small>
                :
                <small className={isConnected?'text-success':'text-danger'}>
                    Your Fitbit account {isConnected?'Is already':'Is NOT'} connected to FitSW{isConnected&&'. You can view Fitbit data in your Progress Graphs.'}
                </small>
            }
        </div>
    )
}

const ClientSettings = () => {
    const dispatch = useDispatch();
    const [showPermissions, setShowPermissions] = useState(false);
    const dataPermissions = useSelector(
        (state) => state.settings.dataPermissions
    );
    useEffect(() => {
        dispatch(getDataPermissions())
    }, [])
    useEffect(() => {
        if (dataPermissions.all_data?.value == 1) {
            setShowPermissions(true);
        } else {
            setShowPermissions(false);
        }
    }, [dataPermissions]);

    return (
        <div className={classes.MainBody}>

            {Object.keys(dataPermissions).length > 0 ?
                <div>
                    <div className={classes.SubHeader}>
                        Data Collection Permissions
                    </div>

                    <div>
                        <div className={classes.PermissionGroup}>
                            <div>{dataPermissions.all_data?.name}</div>
                            <div>
                                {/* <input class="form-check-input" type="checkbox" value={1} onChange={(e) => console.log(e.target.checked)}/> */}
                                <input
                                    class="form-check-input"
                                    type="checkbox"
                                    defaultChecked={dataPermissions.all_data?.value == 1}
                                    onChange={(e) => {
                                        let value = e.target.checked == true ? 1 : 0;
                                        dispatch(updateDataPermissions({ all_data: value }));
                                        setShowPermissions(e.target.checked);
                                    }}
                                />
                            </div>
                        </div>
                        {Object.values(dataPermissions)
                            .filter((permission) => permission.type != "all_data")
                            .map((permission) => (
                                <div className={classes.PermissionGroup}>
                                    <div>{permission.name}</div>
                                    <div>
                                        {showPermissions ? (
                                            <input
                                                class="form-check-input"
                                                type="checkbox"
                                                defaultChecked={permission.value == 1}
                                                onChange={(e) => {
                                                    let value = e.target.checked == true ? 1 : 0;
                                                    dispatch(
                                                        updateDataPermissions({
                                                            [permission.type]: value,
                                                        })
                                                    );
                                                }}
                                            />
                                        ) : (
                                            <div></div>
                                        )}
                                    </div>
                                </div>
                            ))
                        }
                        <div className={classes.SubHeader}>
                            Integrations
                        </div>
                        <ConnectFitbitButton/>
                    </div>
                </div> : (
                    <div
                        style={{
                            position: "absolute",
                            top: "50%",
                            left: "50%",
                            transform: "translate(-50%,-50%)",
                            textAlign: "center",
                        }}
                    >
                        <Spinner animation="border" role="status" variant="primary">
                            <span className="sr-only">Loading...</span>
                        </Spinner>
                    </div>
                )
            }
                   
        </div>
    );
};

export default ClientSettings;
